import { S3BucketType } from "shared/types";

if (!window._env_?.ENV) {
  console.warn("No environment specified, defaulting to 'local'");
}

export const ENVIRONMENT = window._env_?.ENV || "local";
export const isLocalEnv = ENVIRONMENT === "local";
export const isTestEnv = ENVIRONMENT === "test";

export const COMMIT = window._env_?.COMMIT;

export const DATADOG_CLIENT_TOKEN = window._env_?.DATADOG_CLIENT_TOKEN;
export const DATADOG_ENABLED = window._env_?.DATADOG_ENABLED === true;

export const INTERCOM_APP_ID = window._env_?.INTERCOM_APP_ID;
export const INTERCOM_ENABLED = window._env_?.INTERCOM_ENABLED === true;

export const MINERVA_RESOURCES_ENVIRONMENT =
  window._env_?.MINERVA_RESOURCES_ENVIRONMENT || ENVIRONMENT;

export const ROLLBAR_ACCESS_TOKEN = window._env_?.ROLLBAR_ACCESS_TOKEN;
export const ROLLBAR_ENABLED = window._env_?.ROLLBAR_ENABLED === true;

export const S3_BUCKETS: { [k: string]: S3BucketType } = {
  BUG_REPORTS: {
    NAME: window._env_?.S3_BUCKET_BUG_REPORTS_NAME || "forum-bug-reports",
    REGION: window._env_?.S3_BUCKET_BUG_REPORTS_REGION || "us-west-2",
  },
  EMOJIS: {
    NAME: window._env_?.S3_BUCKET_EMOJIS_NAME || "picasso.messaging-resources",
    REGION: window._env_?.S3_BUCKET_EMOJIS_REGION || "us-east-1",
  },
  PICTURES: {
    NAME: window._env_?.S3_BUCKET_PICTURES_NAME || "picasso.fixtures",
    REGION: window._env_?.S3_BUCKET_PICTURES_REGION || "us-east-1",
  },
};

export const FORUM_URL =
  window._env_?.FORUM_URL || `https://${window.location.hostname.replace("class", "forum")}`;
export const GOOGLE_DRIVE_DOMAIN = window._env_?.GOOGLE_DRIVE_DOMAIN || "minervaproject.com";
export const MINERVA_RESOURCES_URL =
  window._env_?.MINERVA_RESOURCES_URL ||
  `https://${window.location.hostname.replace("class", "forum")}`;
export const TLD = window._env_?.TLD;
